import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { LOGO_FULL } from "@/components/common";
import { FREE_COPY } from "@/pages/freelanding/copy";
import { SignupSheet } from "@/pages/freelanding/SignupSheet";
import { COPY } from "@/pages/landing/copy";
import { CheckoutModal } from "@/pages/landing/Checkout";
import { getChallengeCopy, DEFAULT_LOCALE } from "./landingCopy";
import { rsFr } from "./ChallengeShell";
import { Hero, Product, Problem, Examples, Days, Trust, WhyFree, Guide, Builder, Faq, Final } from "./LandingSections";

const LOCALE = DEFAULT_LOCALE;

export default function ChallengeLanding() {
  const { user } = useAuth();
  const nav = useNavigate();
  const t = getChallengeCopy(LOCALE);
  const [signup, setSignup] = useState(null);
  const [checkout, setCheckout] = useState(false);
  const [info, setInfo] = useState(null);
  const [builderPrice, setBuilderPrice] = useState(null);
  const [ideas, setIdeas] = useState([]);
  const [sticky, setSticky] = useState(false);
  useEffect(() => {
    document.documentElement.lang = LOCALE;
    api.get("/public/challenge-info").then((r) => { setInfo(r.data); setBuilderPrice(r.data.builder_price); }).catch(() => {});
    api.get("/public/sample-ideas").then((r) => setIdeas(r.data)).catch(() => {});
    const on = () => setSticky(window.scrollY > 520);
    window.addEventListener("scroll", on, { passive: true });
    return () => window.removeEventListener("scroll", on);
  }, []);
  const start = () => (user ? nav("/dashboard/challenge") : setSignup("/dashboard/challenge"));
  const n = info?.idea_count || "150+";
  const price = info ? rsFr(info.guide_price) : "Rs 595";
  const builder = () => (user ? nav("/challenge/builder") : setSignup("/challenge/builder"));
  return (
    <div className="min-h-screen bg-white pb-20 md:pb-0" data-testid="challenge-landing" lang={LOCALE}>
      <header className="bg-[#13283A] border-b border-white/10"><div className="max-w-5xl mx-auto px-5 h-14 flex items-center"><div className="rounded-lg bg-white px-2 py-1"><img src={LOGO_FULL} alt="Sidebizz" className="h-6" /></div></div></header>
      <Hero t={t} cta={start} loggedIn={!!user} />
      <Product t={t} ideas={ideas} cta={start} />
      <Problem t={t} />
      <Examples t={t} n={n} cta={start} />
      <Days t={t} cta={start} />
      <Trust t={t} />
      <WhyFree t={t} cta={start} />
      <Guide t={t} n={n} price={price} onBuy={() => (user ? nav("/") : setCheckout(true))} onFree={start} />
      <Builder t={t} price={builderPrice ? rsFr(builderPrice) : "Rs 1,490"} onClick={builder} />
      <Faq t={t} n={n} price={price} />
      <Final t={t} cta={start} loggedIn={!!user} />
      {sticky && !signup && !checkout && (
        <div className="md:hidden fixed inset-x-0 bottom-0 z-40 bg-white/95 backdrop-blur border-t border-[#E1ECEF] px-4 pt-3 pb-[max(12px,env(safe-area-inset-bottom))]" data-testid="challenge-sticky-bar">
          <button onClick={start} className="w-full min-h-[52px] rounded-2xl bg-[#13B698] text-white font-extrabold" data-testid="challenge-sticky-cta">{user ? t.hero.ctaLoggedIn : t.sticky}</button>
        </div>
      )}
      <SignupSheet open={!!signup} onOpenChange={(o) => !o && setSignup(null)} a={{ ...FREE_COPY.en.auth, signupS: t.signupSub }} lang="en" redirect={signup || "/dashboard/challenge"} />
      <CheckoutModal open={checkout} onOpenChange={setCheckout} t={COPY.en} lang="en" />
    </div>
  );
}
